import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  constructor() { }
  @Input() redBackground = '';
  @Input() redShape = '';
  @Input() redCol = '';
  @Input() redSize = '';
  ngOnInit(): void {
  }

}
